import {
  DashboardIcon, BranchesIcon, UsersIcon, ReportsIcon,
  ProductsIcon, MedicationsIcon, AdminsIcon,
} from './components/NavIcons';

/**
 * The navigation, as data. The desktop sidebar, the mobile drawer and the
 * bottom bar all render from this one list, so they cannot drift apart.
 */
export const NAV_ITEMS = [
  { id: 'dashboard',   labelKey: 'nav.dashboard',   labelFallback: 'Dashboard',   Icon: DashboardIcon },
  { id: 'branches',    labelKey: 'nav.branches',    labelFallback: 'Branches',    Icon: BranchesIcon },
  { id: 'users',       labelKey: 'nav.users',       labelFallback: 'Users',       Icon: UsersIcon },
  { id: 'reports',     labelKey: 'nav.reports',     labelFallback: 'Reports',     Icon: ReportsIcon },
  { id: 'products',    labelKey: 'nav.products',    labelFallback: 'Products',    Icon: ProductsIcon },
  { id: 'medications', labelKey: 'nav.medications', labelFallback: 'Medications', Icon: MedicationsIcon },
  { id: 'admins',      labelKey: 'nav.admins',      labelFallback: 'Admins',      Icon: AdminsIcon, superAdminOnly: true },
];

export const visibleNavItems = (admin) =>
  NAV_ITEMS.filter((item) => !item.superAdminOnly || Boolean(admin && admin.is_super_admin));

/**
 * The four bottom-bar slots before "More" (spec §4.1). None of them is
 * super-admin only, so the bar has the same shape for every admin — a bar that
 * changes width by role is disorienting.
 */
export const BOTTOM_NAV_IDS = ['dashboard', 'reports', 'branches', 'users'];
